import { Organisation } from '@utilities/types';
import React, { createContext, useState, useEffect, PropsWithChildren } from 'react';
import { PersistDataEnum } from '@utilities/enums';
import { decryptData, encryptData } from '@utilities/functions';

interface OrganisationContextType {
    organisation: Organisation | null;
    setOrganisation: React.Dispatch<React.SetStateAction<Organisation | null>>;
    isUserAdmin: boolean;
    setIsUserAdmin: React.Dispatch<React.SetStateAction<boolean>>;
}

export const OrganisationContext = createContext<OrganisationContextType>({
    organisation: null,
    setOrganisation: () => {},
    isUserAdmin: false,
    setIsUserAdmin: () => {},
});

export const OrganisationContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
    const [organisation, setOrganisation] = useState<Organisation | null>(() => {
        const storedOrganisation = localStorage.getItem(PersistDataEnum.ORGANISATION)
        return storedOrganisation ? JSON.parse(decryptData(storedOrganisation)) : null;
    });
    const [isUserAdmin, setIsUserAdmin] = useState<boolean>(()=> {
        const storedIsUserAdmin = localStorage.getItem(PersistDataEnum.IS_USER_ADMIN);
        return storedIsUserAdmin ? JSON.parse(storedIsUserAdmin) : false;
    });

    useEffect(() => {
        const formatedOrganisation = organisation ? encryptData(organisation) : ''
        localStorage.setItem(PersistDataEnum.ORGANISATION, formatedOrganisation)
        localStorage.setItem(PersistDataEnum.IS_USER_ADMIN, JSON.stringify(isUserAdmin));
    }, [isUserAdmin, organisation]);

    return (
        <OrganisationContext.Provider 
            value={{ 
                organisation, setOrganisation,
                isUserAdmin, setIsUserAdmin
            }}
        >
            {children}
        </OrganisationContext.Provider>
    );
};
